<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="h2"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">CONTENTS</span></p>
<p class="tocf" id="ack"><a href="#/text/Acknowledgments"><i>Acknowledgments</i></a></p>
<p class="toc" id="ch1"><a href="#/text/Chapter01">1.<span style="padding-left:1.2em;">The Pleasures of Backwardness / Zsuzsa Gille, Cristofer Scarboro, and Diana Mincytė</span></a></p>
<p class="toc" id="ch2"><a href="#/text/Chapter02">2.<span style="padding-left:1.2em;">Consuming Dialogues: Pleasure, Restraint, Backwardness, and Civilization in Eastern Europe / Mary Neuburger</span></a></p>
<p class="toc" id="ch3"><span href="#/text/Chapter03" title="Link target outside of Sample">3.<span style="padding-left:1.2em;">Just Rewards: The Social Contract and Communism’s Hard Bargain with the Citizen-Consumer / Patrick Hyder Patterson</span></span></p>
<p class="toc" id="ch4"><span href="#/text/Chapter04" title="Link target outside of Sample">4.<span style="padding-left:1.2em;">Conceptualizing Consumption in the Polish People’s Republic / Brian Porter-Szűcs</span></span></p>
<p class="toc" id="ch5"><span href="#/text/Chapter05" title="Link target outside of Sample">5.<span style="padding-left:1.2em;">Oranges and the New Black: Importing, Provisioning, and Consuming Tropical Fruits and Coffee in the GDR, 1971–89 / Anne Dietrich</span></span></p>
<p class="toc" id="ch6"><span href="#/text/Chapter06" title="Link target outside of Sample">6.<span style="padding-left:1.2em;">VCRs, Modernity, and Consumer Culture in Late State Socialist Poland / Patryk Wasiak</span></span></p>
<p class="toc" id="ch7"><span href="#/text/Chapter07" title="Link target outside of Sample">7.<span style="padding-left:1.2em;">The Enchantment of Imaginary Europe: Consumer Practices in Post-Soviet Ukraine / Tania Bulakh</span></span></p>
<p class="toc" id="ch8"><span href="#/text/Chapter08" title="Link target outside of Sample">8.<span style="padding-left:1.2em;">The Late Socialist Good Life and Its Discontents: <i>Bit</i>, <i>Kultura</i>, and the Social Life of Goods / Cristofer Scarboro</span></span></p>
<p class="toc" id="ch9"><span href="#/text/Chapter09" title="Link target outside of Sample">9.<span style="padding-left:1.2em;">The Prosumerist Resonance Machine: Rethinking Political Subjectivity and Consumer Desire in State Socialism / Zsuzsa Gille and Diana Mincytė</span></span></p>
<p class="tocf" id="ind"><span href="#/text/Index" title="Link target outside of Sample"><i>Index</i></span><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?082647e0